(function AllInclusivePropertiesView($, Adzuki)
{
	"use strict";

	var $property_modal = $("#all-property-modal");

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/AllInclusiveProperties/view/', function onload() {
			var $results_map = $(".aic-map"),
				data         = $results_map.data('results'),
				results_map  = new Adzuki.Map('.aic-map', {zoom: 13});

			results_map.populate(data.map);

			$('.offer-terms-modal').click(function termsModal(e) {
				e.preventDefault();
				
				let $self  = $(this),
					$modal = $('#modalWindow');
				
				e.preventDefault();
				
				$modal.find('.modal-title').text($self.data('modal-title'));
				$modal.find('.modal-body').html($self.data('modal-body'));
				$modal.modal('show');
			});
		});

		$('.cta-link').click(function goToForm(e) {
			e.preventDefault();
			$('#allinclusivecontact-first_name').focus();
		});

		$('.enlarge-image').click(function showImageInModal(e) {
			e.preventDefault();

			// $modal.find('.modal-title').text('Resort Image');
			// $('.modal-dialog').addClass('modal-lg');
			// $modal.find('.modal-body').html('<img src="' + $(this).data('url') +'" class="img-responsive center-block">');
			$('#carousel-inclusive-properties').carousel($(this).data('filename'));
			$property_modal.modal('show');

		});
	});
}(jQuery, window.Adzuki || {}));